
import { useState } from 'react';

export default function useLogin() {
  const getLogin = () => {
    const loginString = localStorage.getItem('login');
    const _login = JSON.parse(loginString);
    console.log(`Editor:`, _login);
    return _login
  };

  const [login, setLogin] = useState(getLogin());

  const saveLogin = __login => {
    localStorage.setItem('login', JSON.stringify(__login));
    setLogin(__login);
  };

  return {
    setLogin: saveLogin,
    login
  }
}